export class Dummy {
    public static getResponse(): any {}
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Dummy/Dummy.ts
 **/